import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class AngelaGptWidget extends UcoastEl {
	static htmlSelector = 'angela-gpt-widget'

	trigger: HTMLButtonElement
	closeButton: HTMLButtonElement
	panel: HTMLElement
	handleDocumentPointerDownBound: (event: PointerEvent) => void
	handleKeydownBound: (event: KeyboardEvent) => void

	constructor() {
		super()
		this.trigger = q.rs<HTMLButtonElement>('.angela-gpt-cta__trigger', this)
		this.closeButton = q.rs<HTMLButtonElement>('.angela-gpt-cta__close', this)
		this.panel = q.rs<HTMLElement>('.angela-gpt-cta__panel', this)
		this.handleDocumentPointerDownBound = this.handleDocumentPointerDown.bind(this)
		this.handleKeydownBound = this.handleKeydown.bind(this)
	}

	override connectedCallback() {
		super.connectedCallback()
		this.trigger.addEventListener('click', this.toggleOpen)
		this.closeButton.addEventListener('click', this.close)
		document.addEventListener('pointerdown', this.handleDocumentPointerDownBound)
		document.addEventListener('keydown', this.handleKeydownBound)
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		this.trigger.removeEventListener('click', this.toggleOpen)
		this.closeButton.removeEventListener('click', this.close)
		document.removeEventListener('pointerdown', this.handleDocumentPointerDownBound)
		document.removeEventListener('keydown', this.handleKeydownBound)
	}

	get isOpen() {
		return this.classList.contains('is-open')
	}

	toggleOpen = () => {
		if (this.isOpen) {
			this.close()
			return
		}
		this.open()
	}

	open = () => {
		this.classList.add('is-open')
		this.trigger.setAttribute('aria-expanded', 'true')
		this.panel.setAttribute('aria-hidden', 'false')
	}

	close = () => {
		this.classList.remove('is-open')
		this.trigger.setAttribute('aria-expanded', 'false')
		this.panel.setAttribute('aria-hidden', 'true')
	}

	handleDocumentPointerDown(event: PointerEvent) {
		if (!this.isOpen) return
		const target = q.ot<PointerEvent, HTMLElement>(event)
		if (!target) return
		if (this.contains(target)) return
		this.close()
	}

	handleKeydown(event: KeyboardEvent) {
		if (event.key !== 'Escape' || !this.isOpen) return
		this.close()
		this.trigger.focus()
	}
}
